import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-QGDN4Y4LCE';

declare global {
  interface Window {
    analytics?: {
      track: (eventName: string, payload?: Record<string, unknown>) => void;
    };
  }
}

const isBrowser = () => typeof window !== 'undefined';

let isInitialized = false;

export const initAnalytics = () => {
  if (!isBrowser() || isInitialized || !GA_MEASUREMENT_ID) {
    return;
  }

  ReactGA.initialize(GA_MEASUREMENT_ID);
  isInitialized = true;

  // Set up analytics facade for consistent API used by hooks/components
  window.analytics = {
    track: (eventName: string, payload: Record<string, unknown> = {}) => {
      ReactGA.event(eventName, payload);
    },
  };

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info('[analytics] initialized GA4 with', GA_MEASUREMENT_ID);
  }
};

export const trackPageView = (path: string) => {
  if (!isInitialized || !isBrowser()) {
    return;
  }

  ReactGA.send({ hitType: 'pageview', page: path });
};

export const isAnalyticsEnabled = () => Boolean(GA_MEASUREMENT_ID);

export { GA_MEASUREMENT_ID };
